import React from "react";
import { ReadonlyFieldProps } from "../types";
import { COLORS, FIELD_COLORS } from "../constants";

const ReadonlyField: React.FC<ReadonlyFieldProps> = ({
  label,
  value,
  labelColor = FIELD_COLORS.defaultLabelColor,
  valueColor = FIELD_COLORS.defaultValueColor,
  valueBgColor = FIELD_COLORS.defaultValueBgColor,
  icon,
}) => (
  <div className="col-md-3 mb-4">
    <label
      className="form-label"
      style={{ color: labelColor, alignItems: "center" }}
    >
      {label}
      {icon && (
        <i
          className={icon}
          style={{ marginLeft: 8, color: COLORS.TEXT_ICON }}
        ></i>
      )}
    </label>
    <div
      style={{
        background: valueBgColor,
        borderRadius: 10,
        padding: "10px 16px",
        color: valueColor,
        alignItems: "center",
        // width: "100%",
      }}
    >
      <label
        style={{
          // display: "block",
          width: "100%",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
        title={String(value) ?? ""}
      >
        {value ?? "-"}
      </label>
    </div>
  </div>
);

export default ReadonlyField;
